import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyWithSpace',
  standalone: false
})
export class CurrencyWithSpacePipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(
    value: number | null | undefined,
    currencyCode: string = 'USD',
    display: 'code' | 'symbol' | 'symbol-narrow' = 'symbol',
    digitsInfo?: string,
    locale: string = 'en-US'
  ): string | null {
    if (value == null) {
      return null; // Return null if the value is explicitly null or undefined
    }

    if (currencyCode === 'MMK') digitsInfo = '1.2-2'; // show 2 dp for mmk

    // Transform the value to the desired currency format
    let formattedCurrency = this.currencyPipe.transform(
      value,
      currencyCode,
      display,
      digitsInfo,
      locale
    );

    if (formattedCurrency) {
      // Match and separate currency code or symbol and value
      const match = formattedCurrency.match(/^([^\d]*)(.*)$/);
      if (match && match[1]) {
        const currencyPart = match[1].trim(); // Get currency code/symbol
        const valuePart = match[2]; // Get the numeric part
        return `${currencyPart} ${valuePart}`; // Add a space after the currency part
      }
    }

    return formattedCurrency;
  }
}
